import React, { useRef } from 'react';
import './PromptEditor.css';

interface PromptEditorProps {
  value: string;
  onChange: (val: string) => void;
  placeholder?: string;
  height?: string;
}

const PromptEditor: React.FC<PromptEditorProps> = ({ value, onChange, placeholder, height }) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const gutterRef = useRef<HTMLDivElement>(null);

  const lines = value.split('\n');
  // Always render at least 1 line number
  const lineCount = Math.max(lines.length, 1);

  // Sync scroll of line numbers gutter and textarea
  const handleScroll = () => {
    if (textareaRef.current && gutterRef.current) {
      gutterRef.current.scrollTop = textareaRef.current.scrollTop;
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Tab') {
      e.preventDefault();
      const textarea = textareaRef.current;
      if (!textarea) return;

      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const newValue = value.substring(0, start) + '    ' + value.substring(end);
      onChange(newValue);

      // Reset selection range after state update
      setTimeout(() => {
        textarea.selectionStart = textarea.selectionEnd = start + 4;
      }, 0);
    }
  };

  return (
    <div className="prompt-editor-container" style={{ height: height || '220px' }}>
      <div className="prompt-editor-gutter" ref={gutterRef}>
        {Array.from({ length: lineCount }).map((_, index) => (
          <div key={index} className="prompt-editor-line-number">
            {index + 1}
          </div>
        ))}
      </div>
      <textarea
        ref={textareaRef}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onScroll={handleScroll}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        spellCheck={false}
        className="prompt-editor-textarea"
      />
    </div>
  );
};

export default PromptEditor;
